<template>
    <div>
        <form v-if="!success" id="MarketingMaterialsOrderForm" @submit.prevent="submit" class="event-form">
            <div class="int-padding pt-0">
                <h3>Contact Information</h3>
                <div class="row clearfix">
                    <div class="col-lg-6 pr-4">
                        <div class="row">
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="first-name">First Name:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.first_name}" id="first-name" v-model="form.first_name"/>
                                    <ValidationError v-if="validationErrors.first_name">{{ validationErrors.first_name }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="last-name">Last Name:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.last_name}" id="last-name" v-model="form.last_name"/>
                                    <ValidationError v-if="validationErrors.last_name">{{ validationErrors.last_name }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="phone">Phone:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.phone}" id="phone" v-model="form.phone"/>
                                    <ValidationError v-if="validationErrors.phone">{{ validationErrors.phone }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="email">Email:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.email}" id="email" type="email" v-model="form.email"/>
                                    <ValidationError v-if="validationErrors.email">{{ validationErrors.email }}</ValidationError>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 pl-4">
                        <div class="row">
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-id">Location ID:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_id}" id="location-id" v-model="form.location_id"/>
                                    <ValidationError v-if="validationErrors.location_id">{{ validationErrors.location_id }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-address">Location Address:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_address}" id="location-address" v-model="form.location_address"/>
                                    <ValidationError v-if="validationErrors.location_address">{{ validationErrors.location_address }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-city">Location City:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_city}" id="location-city" v-model="form.location_city"/>
                                    <ValidationError v-if="validationErrors.location_city">{{ validationErrors.location_city }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-state">Location State:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormSelect :class="{'is-invalid': validationErrors.location_state}" id="location-state" v-model="form.location_state">
                                        <option :value="state" v-for="state in states">{{ state }}</option>
                                    </FormSelect>
                                    <ValidationError v-if="validationErrors.location_state">{{ validationErrors.location_state }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-zip">Location Zip:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_zip}" id="location-zip" v-model="form.location_zip"/>
                                    <ValidationError v-if="validationErrors.location_zip">{{ validationErrors.location_zip }}</ValidationError>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-divider mt-0 mb-0"></div>

            <div v-if="products" class="container-fluid">
                <div class="int-padding">
                    <h3>AAA Marketing Materials Order Form</h3>
                    <div class="row clearfix">
                        <div class="col-lg-6 pr-4">
                            <div class="row">
                                <template v-for="product in products">
                                    <div class="input-group">
                                        <div class="col-lg-6">
                                            <FormLabel :for="product.slug">
                                                <template v-if="product.pack_quantity">
                                                    {{ product.name }} ({{ product.pack_quantity }}/pack):
                                                </template>
                                                <template v-else>
                                                    {{ product.name }}:
                                                </template>
                                                <template v-if="product.subtitle">
                                                    <div v-html="product.subtitle"></div>
                                                </template>
                                            </FormLabel>
                                        </div>
                                        <div class="col-lg-6">
                                            <FormSelect :class="{'is-invalid': validationErrors[`products.${product.slug}`]}" :id="product.slug" v-model="form.products[product.slug]">
                                                <option v-for="(n) in product.max_quantity + 1" :value="n - 1">{{ n - 1 }}</option>
                                            </FormSelect>
                                            <ValidationError v-if="validationErrors[`products.${product.slug}`]">{{ validationErrors[`products.${product.slug}`] }}</ValidationError>
                                        </div>
                                    </div>
                                </template>
                                <div class="input-group">
                                    <div class="col-lg-12 mt-4">
                                        <FormButton :pending="pending" pendingText="Submitting">Submit Request</FormButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="productSlides.length" class="col-lg-6 col-aside order-materials-aside">
                            <div id="OrderFormExamples" class="carousel slide carousel-static" data-ride="carousel">
                                <ol v-if="productSlides.length > 1" class="carousel-indicators order-form-example-nav">
                                    <li v-for="(productSlide, index) in productSlides" :data-target="`#OrderFormExamples`" :data-slide-to="index" :class="{active: index === 0}"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div v-for="(productSlide, index) in productSlides" :id="`product-slide-${index}`" class="carousel-item" :class="{active: index === 0}">
                                        <template v-if="productSlide.length">
                                            <div v-for="product in productSlide" :id="product.slug" class="row guide-row">
                                                <div class="col-md-4 guide-img">
                                                    <template v-if="product.download">
                                                        <img src="/images/global/download-arrow.svg" alt="download" class="download-btn download-btn-sm">
                                                        <a :href="product.download_public_path" target="_blank">
                                                            <img :src="product.image_public_path" :alt="product.name" class="guide-photo">
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <img :src="product.image_public_path" :alt="product.name" class="guide-photo">
                                                    </template>
                                                </div>
                                                <div class="col-md-8">
                                                    <div class="guide-details">
                                                        <div class="title mb-0">{{ product.name }}</div>
                                                        <div class="rev-date"></div>
                                                        <p>{{ product.description }}</p>
                                                        <p v-if="product.download">If you need immediate Supply, <a :href="product.download_public_path" target="_blank">download here</a>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="errorMessage" class="mt-3 alert alert-danger">
                <p class="mb-0">{{ errorMessage }}</p>
            </div>
        </form>
        <MarketingMaterialsOrderConfirmation v-else :order="order"/>
    </div>
</template>

<script>
import FormLabel from '@/components/form/FormLabel';
import FormInput from '@/components/form/FormInput';
import ValidationError from '@/components/form/ValidationError';
import FormMixin from '@/mixins/FormMixin';
import FormSelect from '@/components/form/FormSelect';
import { states } from '@/states';
import MarketingService from '@/services/marketing.service';
import FormButton from '@/components/form/FormButton';
import MarketingMaterialsOrderConfirmation from '@/components/marketing/MarketingMaterialsOrderConfirmation';

const DEFAULT = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    location_id: '',
    location_address: '',
    location_city: '',
    location_state: '',
    location_zip: '',
    products: {}
};

const EMPLOYEE = {
    first_name: '',
    last_name: '',
    email: '',
    location_code: '',
};

export default {
    components: {
        MarketingMaterialsOrderConfirmation,
        FormButton,
        FormLabel,
        FormSelect,
        FormInput,
        ValidationError
    },
    mixins: [
        FormMixin
    ],
    props: {
        employee: {
            type: Object,
            default() {
                return EMPLOYEE;
            }
        },
        products: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            states: states,
            form: {...DEFAULT, ...{
                first_name: this.employee.first_name,
                last_name: this.employee.last_name,
                email: this.employee.email,
                location_id: this.employee.location_code,
             }},
            order: {}
        }
    },
    created() {
      this.products.forEach(product => {
         this.form.products[product.slug] = 0;
      });
    },
    computed: {
      productSlides() {
          if (this.products.length) {
              return _.chunk(this.products, 5);
          }

          return [];
      }
    },
    methods: {
        async submit() {
            this.pending = true;
            this.errorMessage = '';
            this.errorStatusCode = null;
            this.validationErrors = {};

            try {
                this.order = await MarketingService.order(this.form);
                this.success = true;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.pending = false;
            }
        }
    }
}
</script>
